import React from "react";
import { Grid, IconButton, Avatar } from '@material-ui/core'
import {
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Button,
  FormControlLabel,
  Switch,
  Hidden,
  Typography
} from "@material-ui/core";
import { RemoveCircle, Create, Close, Check } from "@material-ui/icons";
import PermissionsStore from "../../stores/PermissionsStore";
import SearchUserToAction from '../SearchUserToAction';
import withSnack from "../withSnack";
import extract_user from '../../functions/extract'

export class SearchUserPerm extends React.Component {
  constructor(props) {
    super(props);
    if (this.getStore === undefined) {
      throw new TypeError("Must override getStore");
    }
    this.state = {
      users: [],
      isModalManPermOpen: false,
      action: '',
      user: ''
    };
  }

  componentDidMount() {
    const { type } = this.props;
    const users = this.getStore().listUsers(type);
     if(users !== undefined){
       users.then(r => {
         this.setState({ users: r.data });
       });
     }
  }

  getStore() {
    return PermissionsStore;
  }

  openManPermModal = (user, type, action) => {
    this.setState({ isModalManPermOpen: true, action: action, user: user })
  }

  closeManPermModal = () => {
    this.setState({ isModalManPermOpen: false, action: '', user: '' })
  }

  userAlreadyHasPermission = (arr, user) => {
    return arr.some(function(el){
      return (el.id === user.id  || el.email === user.email)
    })
  }

  givePermission = (user, permission, op) => {
    const arr = this.state.users;
    const checkUser = this.userAlreadyHasPermission(arr, user)
    //check if user already has this permission
    if(checkUser === true){
          this.props.snack('El usuario ya tiene este permiso', 'warning')
          this.closeManPermModal();
    }
    else{
      this.getStore()
        .addPermission(user.id, permission, op)
        .then(r => {
          this.props.snack('Se asignó el permiso con éxito', 'success')
          this.setState(prevState => {
            return {
              users: [user,...prevState.users]
            };
          });
        })
        .catch(() => {
          this.props.snack('Ocurrió un error', 'warning')
        })
        this.closeManPermModal();
    }
  };

  removePermission = (user, permission) => {
    this.getStore()
      .removePermission(user.id,permission)
      .then(r => {
        this.props.snack('Se revocó el permiso con éxito', 'success')
        this.setState(prevState => {
          return { users: prevState.users.filter(x => x.id !== user.id) };
        });
      })
      .catch(() => {
        this.props.snack('Ocurrió un error', 'warning')
      })
      this.closeManPermModal();
  };

  editPermission = (user, needs_approval) => {
      this.getStore()
        .editPermission(user.id, needs_approval)
        .then(r => {
          this.props.snack('Se modificó el permiso con éxito', 'success')
          this.setState(prevState => {
            return {
              users: [{...user, needs_approval: needs_approval},...prevState.users.filter(x => x.id !== user.id)]
            };
          });
        })
        .catch(() => {
          this.props.snack('Ocurrió un error', 'warning')
        })
        this.closeManPermModal();
  };

  render() {
    const { users, isModalManPermOpen, action, user } = this.state;
    const { type } = this.props;
    return (
      <Grid container justify="space-between" direction="row" alignItems="flex-start">
        <Grid item lg={12} xl={12} md={12} sm={12} xs={12}>
          <SearchUserToAction
            onChange={this.openManPermModal}
            includeGroups={false}
            type={type}
          />
        </Grid>
        <Grid item lg={12} xl={12} md={12} sm={12} xs={12} className="subsection_container_list">
          <List>
            { type === 'Create'? <Hidden only={['xs','sm']}><Grid container><Grid item xs={2} sm={2} md={2} lg={9} xl={10}></Grid><Grid item xs={2} sm={2} md={2} lg={2} xl={2} className="option_header">Revisión de oficio</Grid></Grid></Hidden> : null }
            {users.map(u => (
              <ListItem key={u.id} style={{padding:"10px 0px"}}>
                <Avatar alt="avatar" className="avatar">{u.name.full.slice(0,2)}</Avatar>
                <ListItemText primary={u.temp? u.name.full : u.name.title+' '+u.name.full} secondary={extract_user(u.email)} />
                <ListItemSecondaryAction>
                  { type === 'Create'? <React.Fragment>
                    {u.needs_approval ? <Check className="check"/> : <Close className="unavailable"/>}
                    <IconButton onClick={(e) => this.openManPermModal(u, type, 'Edit')} style={{padding: 0, marginRight: 20}}><Create /></IconButton></React.Fragment>
                  : null }
                  <IconButton onClick={(e) => this.openManPermModal(u, type, 'Remove')} style={{padding: 0}}>
                    <RemoveCircle />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            ))}
          </List>
        </Grid>
        {isModalManPermOpen?
          <ModalConfirmation
          isModalManPermOpen={isModalManPermOpen}
          closeManPermModal={this.closeManPermModal}
          type={type}
          action={action}
          removePermission={this.removePermission}
          givePermission={this.givePermission}
          editPermission={this.editPermission}
          user={user}
        />: null }
      </Grid>
    );
  }
}

export const ModalConfirmation = props => {
  const { isModalManPermOpen, closeManPermModal, type, action, removePermission, givePermission, editPermission, user } = props;
  const [state, setState] = React.useState({
    needsAproval: (typeof user.needs_approval !== 'undefined')? user.needs_approval : false,
    })

  const { needsAproval } = state;
  let options = null;

  const handleChange = () => {
    setState({ needsAproval: !needsAproval });
  }

  if((type === 'Create') && (action !== 'Remove')){
    options = (
      <React.Fragment>
        <Grid container
            direction="row"
            alignItems="center">
              <Grid item xs={7} sm={7} md={7} lg={7}  xl={7}>
                <Typography variant="body1">Revisar oficio redactado por delegado</Typography>
              </Grid>
              <Grid item xs={5} sm={5} md={5} lg={5}  xl={5}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={needsAproval}
                      onChange={handleChange}
                      name="external"
                      color="primary"
                    />}
                    label={needsAproval? 'Activado' : 'Desactivado'}
                  />
              </Grid>

        </Grid>
      </React.Fragment>
    );
  }

  let text_action, button;
  let text_desc = 'crear oficios';
  text_action = button = 'asignar';
  let action_execute = () => givePermission(user, type, needsAproval);

  if(type !== 'Create'){
    text_desc = 'otorgar permisos';
  }

  switch(action){
    case 'Edit':
      text_action = button = 'modificar';
      action_execute = () => editPermission(user, needsAproval);
    break;
    case 'Remove':
      text_action = button = 'revocar';
      action_execute = () => removePermission(user, type);
    break;
    default:
    break;
  }

  return(
    <Dialog
     open={isModalManPermOpen}
     onClose={closeManPermModal}
    >
     <DialogTitle id="draggable-dialog-title">Confirmación</DialogTitle>
     <DialogContent>
         ¿Realmente desea {text_action} el permiso de {text_desc}  a {user.name.full}?
         <br/>
         {options}
     </DialogContent>
     <DialogActions className="button_modal">
       <Button onClick={closeManPermModal} color="primary">
         Cancelar
       </Button>
       <Button onClick={action_execute} color="primary">
         {button}
       </Button>
     </DialogActions>
   </Dialog>
  )
}

SearchUserPerm.propTypes = {};

export default withSnack(SearchUserPerm);



// WEBPACK FOOTER //
// ./src/components/containers/SearchUserPerm.js